import { render } from "./DataTiketDetail.vue?vue&type=template&id=13bd3286&scoped=true"
import script from "./DataTiketDetail.vue?vue&type=script&lang=js"
export * from "./DataTiketDetail.vue?vue&type=script&lang=js"

import "./DataTiketDetail.vue?vue&type=style&index=0&id=13bd3286&scoped=true&lang=css"

import exportComponent from "/Users/vitechasia/Documents/Kantor/project_nuxt/vuess/vtadesk-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bd3286"]])

export default __exports__